import { useCallback, useEffect, useRef } from 'react';

/**
 * Persona's `onComplete` only means the landlord finished the steps — the state it settles on can be
 * NEEDS_REVIEW, FAILED or PENDING, so `onVerified` runs only once the server confirms.
 */
export const useVerificationCompletion = ({
  isVerified,
  onVerified,
  reset,
  refetchState,
}: {
  isVerified: boolean;
  onVerified: () => void;
  reset: () => void;
  refetchState: () => void;
}) => {
  // Once: a repeat advance skips the publish step, and a repeat notify double-signals the app.
  const hasFiredRef = useRef(false);

  useEffect(() => {
    if (!isVerified || hasFiredRef.current) return;
    hasFiredRef.current = true;
    onVerified();
  }, [isVerified, onVerified]);

  return useCallback(() => {
    reset();
    refetchState();
  }, [reset, refetchState]);
};
